import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
  return {
    wrapper: {
      flexGrow: 1,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: '100%',
      marginTop: '80px',
    },
    mobileWrapper: {
      flexGrow: 1,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: '100%',
      marginTop: '0px',
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
    content: {
      flexGrow: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    mobileContent: {
      flexGrow: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
    footer: {
      marginTop: 'auto',
      padding: theme.spacing(2, 0),
    },
  };
});

export default useStyles;
